import React, { Fragment, PureComponent } from "react";
import callGetEmployeeDetail from "api/Employee/callGetEmployeeDetail";

export default class EmployeeInfoView extends PureComponent {
  static defaultProps = {
    field: "name",
  };

  static cachedEmployeeInfo = {};

  state = {
    data: null,
  };

  componentDidMount() {
    const { id } = this.props;
    if (!id) {
      this.setState({ data: null });
    } else {
      this._fetchData(id);
    }
  }

  componentDidUpdate(prevProps) {
    const { id } = this.props;
    if (prevProps.id !== id) {
      if (!id) {
        this.setState({ data: null });
      } else {
        this._fetchData(id);
      }
    }
  }

  _fetchData = async (id) => {
    try {
      let data = EmployeeInfoView.cachedEmployeeInfo[id];
      if (!data) {
        data = await callGetEmployeeDetail({ id });
        EmployeeInfoView.cachedEmployeeInfo[id] = data;
      }

      this.setState({
        data,
      });
    } catch (e) {
      this.setState({
        data: null,
      });
    }
  };

  render() {
    const { data } = this.state;
    const { field } = this.props;
    return <Fragment>{data ? data[field] : ""}</Fragment>;
  }
}
